import { useState, useEffect } from "react";
import { getConfig } from "../config/runtimeConfig";

/**
 * Custom hook for debouncing values
 * @param value - The value to debounce
 * @param delay - The delay in milliseconds
 * @returns The debounced value
 */
function useDebounce<T>(value: T, delay?: number): T {
  const defaultDelay =
    delay || Number(getConfig("REACT_APP_DEBOUNCE_DELAY") || 400);
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Set up a timer to update the debounced value after the delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, defaultDelay);

    // Clean up the timer if the value changes before the delay
    return () => {
      clearTimeout(handler);
    };
  }, [value, defaultDelay]);

  return debouncedValue;
}

export default useDebounce;
